import { getAccessiblePortals, Icon, useHasAuthorization, WelcomePage } from '@eagle/react-common';
import { Typography } from '@ethings/ui-toolkit';
import { useTheme } from '@mui/material';
import { FC, type JSX } from 'react';
import { useTranslation } from 'react-i18next';

export const Welcome: FC = (): JSX.Element => {
  const theme = useTheme();
  const { t } = useTranslation(['common', 'track']);
  const { hasAuthorization } = useHasAuthorization();
  const accessiblePortals = getAccessiblePortals(hasAuthorization).filter((portal) => portal !== 'track');

  const renderLogo = (smallScreen: boolean): JSX.Element => <Icon icon="MapPin"
    style={{
      alignSelf: 'center',
      color: theme.palette.primary.main,
      height: smallScreen ? 60 : 100,
      width: smallScreen ? 60 : 100,
    }}
  />;

  const renderTitle = (smallScreen: boolean): JSX.Element => <>
    <Typography fontWeight={400} variant={smallScreen ? 'h5' : 'h4'}>{t('common:page.welcome.title')}</Typography>
    <Typography fontWeight={600} marginTop={1} variant={smallScreen ? 'h5' : 'h4'}>{t('common:common.labels.portal-name', { display: t('common:common.labels.track') })}</Typography>
  </>;

  const renderText = (smallScreen: boolean): JSX.Element => <>
    <Typography variant={smallScreen ? 'body2' : 'body1'}>{t('common:page.welcome.hint.no-permissions')}</Typography>
    <Typography variant={smallScreen ? 'body2' : 'body1'}>{t('common:page.welcome.hint.contact-admin')}</Typography>
  </>;

  return <WelcomePage accessiblePortals={accessiblePortals} renderLogo={renderLogo} renderText={renderText} renderTitle={renderTitle} title={t('common:common.labels.track')} />;
};
